<template>
  <div class="malib-filter">
    <ul class="list-wrapper" v-if="malibConf.data.length > 0">
      <li
        v-for="(item, $index) in malibConf.data"
        v-show="lock($index)"
        :key="$index"
        class="list"
      >
        <div @click="cut(item.id)" class="tab" >
          <div v-text="item.name" class="tab-name" :class="[countFlag($index), {'act': malibConf.id === item.id}]" ></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  var count = 0;

  export default {
    name: "malib_filter",
    props: ['malibConf'],
    data() {
      return {
        count: 0
      }
    },
    methods: {
      lock(index) {
        return this.$props.malibConf.lock && index > 0? false: true;
      },
      cut(id) {
        this.$emit('cut', {id, type:4, paging:false});
      },
      countFlag(index) {
        count = count < 7 ? count += 1 : 1;
        var _res = 'item' + count;
        if ((index + 1) === this.$props.malibConf.data.length) {
          count = 0;
        }
        return _res;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/malib_filter.vue